import { ErrorMessageContents } from '../../helpers/hub'
import { User } from './types'

export const userFetch = () => ({ type: 'users.fetch' } as const)
type UserFetchAction = ReturnType<typeof userFetch>

export const userAddUser = (users: User[]) =>
  ({ type: 'users.addUsers', payload: users } as const)
export type UserAddUserAction = ReturnType<typeof userAddUser>

export const userFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'users.fetchFail', payload: error, error: true } as const)
export type UserFetchFailAction = ReturnType<typeof userFetchFail>

export const setSelectedUser = (userId: number) =>
  ({ type: 'users.setSelectedUser', payload: userId } as const)
export type UserSetSelectedUserAction = ReturnType<typeof setSelectedUser>

export type UsersAction =
  | UserFetchAction
  | UserAddUserAction
  | UserFetchFailAction
  | UserSetSelectedUserAction
